import {
  client,
  DevicesControllerListAvailableComponentVersionsData,
  SitesControllerListAvailableComponentVersionsData,
} from "@/client";
import { createTableContext } from "@/components/custom/data-table/data-table-context";
import { isDefined } from "@/lib/utils";
import { useColumns } from "./service-version-selection-columns";
import { ServiceVersionDto } from "@/client";

export const BulkDeviceServiceVersionSelectionTableContext = createTableContext<
  ServiceVersionDto,
  DevicesControllerListAvailableComponentVersionsData
>({
  queryArgument: () => ({
    componentName: "edgify-agent",
    page: 1,
    limit: 10,
  }),
  getRowId: (row) => {
    if (isDefined(row?.version)) {
      return `${row.version}`;
    }
    console.warn("undefined row.version", row);
    return ``;
  },
  queryCreator: (...args) =>
    client.devices.listAvailableComponentVersions.asQueryOptions(...args),
  enableMultiRowSelection: false,
  columns: useColumns,
  searchLabel: "Version",
  searchField: "version",
  itemType: "Versions",
  enableGallery: false,
});

export const BulkSiteServiceVersionSelectionTableContext = createTableContext<
  ServiceVersionDto,
  SitesControllerListAvailableComponentVersionsData
>({
  queryArgument: () => ({
    componentName: "edgify-agent",
    page: 1,
    limit: 10,
  }),
  getRowId: (row) => {
    if (isDefined(row?.version)) {
      return `${row.version}`;
    }
    console.warn("undefined row.version", row);
    return ``;
  },
  queryCreator: (...args) =>
    client.sites.listAvailableComponentVersions.asQueryOptions(...args),
  enableMultiRowSelection: false,
  columns: useColumns,
  searchLabel: "Version",
  searchField: "version",
  itemType: "Versions",
  enableGallery: false,
});
